import React from 'react';
import { Card, Table } from '@avila-tek/ui/src';
import { createColumnHelper } from '@tanstack/react-table';
import { Plan } from '../../models';

export interface SubscriptionItem extends Plan {
  employeesCount: number;
}
interface AllSubscriptionTableProps {
  data: SubscriptionItem[];
  setPlanSelected: React.Dispatch<React.SetStateAction<Plan>>;
}

const columnHelper = createColumnHelper<SubscriptionItem>();

const columns = [
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore library has a issue: https://github.com/TanStack/table/issues/4224
  columnHelper.accessor('title', {
    header: 'Nombre',
    cell: (info) => `${info?.row.original.title}`,
  }),

  columnHelper.accessor('employeesCount', {
    header: 'Beneficiarios',
    cell: (info) => `${info?.row.original.employeesCount}`,
  }),
];

function AllSubscriptionTable({
  data,
  setPlanSelected,
}: AllSubscriptionTableProps) {
  const onClickRow = (e: React.MouseEvent<HTMLTableRowElement, MouseEvent>) => {
    e.preventDefault();
    const { id } = e.currentTarget.dataset;

    const newPlanSelected = data.find((plan) => plan._id === id);
    setPlanSelected(newPlanSelected);
  };

  return (
    <Card>
      <Table<SubscriptionItem>
        data={data}
        columns={columns}
        href="/app/users/create"
      >
        <Table.Header className="p-6 w-full flex justify-between">
          <Table.SearchInput />
        </Table.Header>
        <Table.Content<SubscriptionItem> onClickRow={onClickRow} />
        <Table.Footer>
          <Table.Pagination className="ml-auto" />
        </Table.Footer>
      </Table>
    </Card>
  );
}

export default AllSubscriptionTable;
